import { Tool } from '../../types';

export const emailTools: Tool[] = [
  {
    id: 'gmail',
    name: 'Gmail',
    category: 'Email Services',
    description: 'Professional email service with advanced features',
    pricing: ['free', 'low'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['service-business', 'content-creator'],
    goals: ['streamline-operations'],
    industries: ['technology', 'creative', 'marketing'],
    website: 'https://gmail.com',
    imageUrl: 'https://logo.clearbit.com/gmail.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'outlook',
    name: 'Microsoft Outlook',
    category: 'Email Services',
    description: 'Email and calendar solution for businesses',
    pricing: ['low', 'medium'],
    features: ['integrations', 'mobile', 'security'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'consulting-firm'],
    goals: ['streamline-operations'],
    industries: ['technology', 'finance', 'consulting'],
    website: 'https://outlook.com',
    imageUrl: 'https://logo.clearbit.com/microsoft.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'protonmail',
    name: 'ProtonMail',
    category: 'Email Services',
    description: 'Secure and encrypted email service',
    pricing: ['free', 'low', 'medium'],
    features: ['security', 'mobile', 'ease-of-use'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['consulting-firm', 'service-business'],
    goals: ['security', 'streamline-operations'],
    industries: ['finance', 'healthcare', 'technology'],
    website: 'https://proton.me/mail',
    imageUrl: 'https://logo.clearbit.com/proton.me',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];